import { FaStar, FaBoxOpen } from "react-icons/fa";

const categories = [
  {
    icon: <FaStar />,
    title: "Speciality Paper",
    desc: "Premium release and label-grade papers for specialized applications.",
    items: [
      "CCK Release Base Paper (Label Stock)",
      "SCK Release Base Paper (Label Stock)",
      "Chromo Labels",
      "Glassine Release Base Paper",
    ],
  },
  {
    icon: <FaBoxOpen />,
    title: "Packaging Board",
    desc: "Durable, coated boards engineered for packaging and print performance.",
    items: [
      "Greeseproof Board",
      "Folding Box Board (FBB)",
    ],
  },
];

export default function ProductCategories() {
  return (
    <section className="categories">
      <h2>Product Categories</h2>

      <div className="category-grid">
        {categories.map((category) => (
          <div className="category-card" key={category.title}>
            <div className="category-icon">{category.icon}</div>

            <h4>{category.title}</h4>

            <p>{category.desc}</p>

            <ul className="category-items">
              {category.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}